import script from "./DepthContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./DepthContainer.vue?vue&type=script&setup=true&lang=js"

import "./DepthContainer.vue?vue&type=style&index=0&id=7a326579&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7a326579"]])

export default __exports__